module.exports = __webpack_public_path__ + "img/hunzilogin.7b57ba09.png";